module.exports = __webpack_public_path__ + "media/houseandland.eb222b5d.svg";